import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { ProductsBiocatchEnum, StepBiocatchEnum, } from 'src/app/shared/enums/biocatchContext.enum';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { ConfigurationService } from 'src/app/shared/services/configuration/configuration.service';
import { CryptoVaultService } from 'src/app/shared/services/external/crypto-vault/crypto-vault.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { BUSINESS_CONST } from '../../../shared/constants/business.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import { IsPEP } from '../../../shared/models/fi.model';
import { LogDeviceModel } from '../../../shared/models/log-device.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { ChannelCommunicatorService } from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { ValidationHelperService } from '../../../shared/services/helpers/validation-helper.service';
import { IdentificationService } from '../../../shared/services/identification/identification.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { ProductsService } from '../../../shared/services/products/products.service';
import { SignOnService } from '../../../shared/services/sign-on/sign-on.service';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { DaliService } from '@dali/tagger-ng8';
import { PAGEVIEW as PAGEVIEW_FA, CHANNEL as CHANNEL_FA, COUNTRY as COUNTRY_FA, BUSINNESS as BUSINNESS_FA, ENVIRONMENT as ENVIRONMENT_FA, FAMILY as FAMILY_FA, SUBFAMILY as SUBFAMILY_FA, PRODUCT as PRODUCT_FA, } from 'src/app/shared/constants/dali-fa-tc.constants';
import { EVENT as EVENT_FA_LD } from 'src/app/shared/constants/dali-fa-ld.constants';
/**./
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
var PoliticallyExposedPersonComponent = /** @class */ (function () {
    /**
     * Constructor inicial del componente
     *
     * *Component initial constructor*
     * @param {CopyService}
     * @param {NavigationService}
     * @param {AbreCuentasService}
     * @param {BioCatchService}
     * @param {HeaderService}
     * @param {IdentificationService}
     * @param {ParametersService}
     * @param {ChannelCommunicatorService}
     */
    function PoliticallyExposedPersonComponent(copyService, navigationService, abreCuentasService, bioCatchService, headerService, identificationService, parametersService, channelCommunicatorService, taggingServices, signOnService, configurationService, requestService, productsService, validatorHelperService, bitacoraService, loaderService, cipherService, helpersService, firmlyApprovedService, captureService, daliService, taggingService) {
        this.copyService = copyService;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.bioCatchService = bioCatchService;
        this.headerService = headerService;
        this.identificationService = identificationService;
        this.parametersService = parametersService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.taggingServices = taggingServices;
        this.signOnService = signOnService;
        this.configurationService = configurationService;
        this.requestService = requestService;
        this.productsService = productsService;
        this.validatorHelperService = validatorHelperService;
        this.bitacoraService = bitacoraService;
        this.loaderService = loaderService;
        this.cipherService = cipherService;
        this.helpersService = helpersService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.captureService = captureService;
        this.daliService = daliService;
        this.taggingService = taggingService;
        /**
         * Valida si el botón esta habilitado o no
         *
         * *Validates if the button is enabled or not*
         * @access public
         * @type {boolean}
         */
        this.isBtnDisabled = true;
        /**
         * Variable de validación para mostrar modal
         *
         * *Validation variable to showModal*
         *
         * @access public
         * @type {boolean}
         */
        this.showModal = false;
        /**
         * Objeto de tipo IsPEP
         *
         * *IsPEP object*
         * @access public
         * @type {IsPEP}
         */
        this.IsPEP = new IsPEP();
        /**
         * Lista de opciones de raddio buttons
         *
         * *Options list for raddio buttons*
         *
         * @access public
         * @type {Array<any>}
         */
        this.listIsPEP = [];
        this.infoDocument = new DocumentModel();
        this.temproducts = [];
        this.devicePrint = new LogDeviceModel();
        this.headerService.show(true, true, true);
        this.has_second_headline = this.abreCuentasService.getSecondHeadline()
            ? this.abreCuentasService.getSecondHeadline().has_second_headline
            : false;
    }
    /**
     * Función que se ejecuta cuando de inicia el componente
     *
     * *Executes when component is run*
     */
    PoliticallyExposedPersonComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isFirmlyApproved, product, productType;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.postLogin = this.abreCuentasService.getPostlogin();
                        this.infoDocument = this.abreCuentasService.getDocumentInfo();
                        this.productSelected = this.abreCuentasService.getproductSelected();
                        if (!(!this.postLogin && this.productSelected.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING)) return [3 /*break*/, 2];
                        console.warn('Se procederá a validación de Documentos.....');
                        return [4 /*yield*/, this.validateClientData()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.sendTagging('init');
                        isFirmlyApproved = this.firmlyApprovedService.isFirmlyApproved();
                        if (isFirmlyApproved && this.abreCuentasService.getProductsSelects().length === 1) {
                            this.sendPEPPageLoad();
                        }
                        this.channelId = this.channelCommunicatorService.getChannelId();
                        this.checkBioCatch();
                        product = this.abreCuentasService.getproductSelected()
                            .product_code;
                        if (product !== ProductsBiocatchEnum.VIV && !this.bioCatchService.isAppCN()) {
                            this.bioCatchService.changeContext(StepBiocatchEnum.identificacion, product, this.bioCatchService.isVivCn(product));
                        }
                        this.transaction_id = this.abreCuentasService.getTransactionId();
                        this.product_type = this.productSelected
                            ? this.productSelected.product_type
                            : '';
                        this.listIsPEP = [
                            {
                                label: this.copyService.copies.identification_pep_yes,
                                elementId: 1,
                                checked: this.abreCuentasService.getListIsPEP() === this.copyService.copies.identification_pep_yes,
                            },
                            {
                                label: this.copyService.copies.identification_pep_no,
                                elementId: 2,
                                checked: this.abreCuentasService.getListIsPEP() === this.copyService.copies.identification_pep_no,
                            },
                        ];
                        this.FiProperty();
                        if (this.channelId === CHANNEL.PORTALO.CODE) {
                            this.postLogin = true;
                        }
                        if (!this.postLogin) {
                            return [2 /*return*/, this.enableNextButton()];
                        }
                        this.terms = {
                            text: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0]
                                .description,
                            title: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].code,
                            terms_id: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].id,
                        };
                        this.checkboxTerms = {
                            id: this.terms.terms_id,
                            label: 'Autorizo el tratamiento de mis datos según la siguiente política: ',
                            checked: false,
                            value: this.terms.terms_id,
                        };
                        if (!!this.has_second_headline) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.callClientExistInformationService()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        productType = this.abreCuentasService.getproductSelected().product_type;
                        if ((productType === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                            productType === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
                            productType === BUSINESS_CONST.PRODUCT_TYPE_TC ||
                            productType === BUSINESS_CONST.MULTI ||
                            (this.channelId === CHANNEL.PORTALO.CODE && productType === BUSINESS_CONST.PRODUCT_TYPE_LIVING && !this.isNewClient))) {
                            this.keyCipherExchange();
                        }
                        // Valida si el cliente va por el flujo de aprobados en firme, de ser asi valida sus solicitudes.
                        if (isFirmlyApproved) {
                            this.validateRequestsGZAF();
                        }
                        if (!this.abreCuentasService.getPostlogin()) {
                            this.encripmethod();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PoliticallyExposedPersonComponent.prototype.validateClientData = function () {
        var clientData = this.abreCuentasService.getRescueData();
        console.log('Ingresando a la validación de documentos');
        if (clientData.number_id !== this.infoDocument.document_number) {
            console.error('---------------- FRAUDE --------------');
            this.saveBitacora('Documento Escaneado : ' + this.infoDocument.document_number + '- Posible Fraude');
            this.saveBitacora('Identificacion_Coincide_No');
            this.navigationService.navigateToGeneralInformation('102');
        }
        console.log('Validación Exitosa de Documentos');
    };
    PoliticallyExposedPersonComponent.prototype.saveBitacora = function (message) {
        this.bitacoraService.saveDataInBitacora(message);
    };
    PoliticallyExposedPersonComponent.prototype.encripmethod = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cipherService
                            .encrypt(this.abreCuentasService.getDocumentInfo().document_number + "_" + this.abreCuentasService.getDocumentInfo().document_type.replace('0', ''))
                            .then(function (data) {
                            _this.descrip = data;
                            console.log(_this.descrip);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Validar pais de la persona para aprobados en firme
     *
     * *Validate the person's country for firmly approved
     */
    PoliticallyExposedPersonComponent.prototype.checkBioCatch = function () {
        var _this = this;
        if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
            this.abreCuentasService.showGenericLoading();
            this.bioCatchService.checkCountry(false).then(function (response) {
                _this.abreCuentasService.hideGenericLoading();
                if (!response.data.response && _this.bioCatchService.getGeoServiceComplete()) {
                    _this.navigationService.navigateToGeneralInformation('dsbException');
                }
                else {
                    var biocatchInfo = _this.bioCatchService.getBiocatchInfo();
                    if (biocatchInfo && !!biocatchInfo.ipGeoCity && !!biocatchInfo.ipGeoCountry) {
                        var bitacoraEventGeo = "geo_biocatch_" + biocatchInfo.ipGeoCity + "_" + biocatchInfo.ipGeoCountry;
                        _this.bitacoraService.saveDataInBitacora(bitacoraEventGeo);
                    }
                }
            }, function () {
                _this.abreCuentasService.hideGenericLoading();
                _this.navigationService.navigateToGeneralInformation('500');
            }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
        }
    };
    PoliticallyExposedPersonComponent.prototype.productChannel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var arrayProduct, requestData, multiGrayZone_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        arrayProduct = this.parametersService.getSetting('productPolitical');
                        return [4 /*yield*/, this.captureService.getRequestsByClient(this.descrip)];
                    case 1:
                        requestData = _a.sent();
                        if (this.abreCuentasService.getproductSelected().product_type === 'multi') {
                            multiGrayZone_1 = false;
                            this.abreCuentasService.getProductsSelects().forEach(function (el) {
                                if (_this.captureService.maProduct(requestData, el.product_type)) {
                                    console.log('datos');
                                    multiGrayZone_1 = true;
                                }
                            });
                            if (multiGrayZone_1) {
                                this.navigationService.navigateToGeneralInformation('129');
                                this.bitacoraService.saveDataInBitacora('pending_process');
                            }
                        }
                        else if (arrayProduct.includes(this.abreCuentasService.getproductSelected().product_type)) {
                            if (this.captureService.maProduct(requestData, this.abreCuentasService.getproductSelected().product_type)) {
                                this.navigationService.navigateToGeneralInformation('129');
                                if (this.postLogin === true) {
                                    this.navigationService.pageLoadTag('ErrorProcesoEnTramite', ['pv426', '', 'pv572', '']);
                                }
                                console.log('AQUI');
                                this.bitacoraService.saveDataInBitacora('pending_process');
                                return [2 /*return*/, true];
                            }
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    PoliticallyExposedPersonComponent.prototype.keyCipherExchange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var limitMaxProducts;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.warn('Entró en PEP por keyCipherExchange ------');
                        limitMaxProducts = this.parametersService.getSetting(OpEnum.MAX_COUNT_PRODUCTS);
                        return [4 /*yield*/, this.requestService
                                .clientProduct()
                                .then(function (res) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var productType, products_ord, products_tc, products_tc_1, products_ord_1, products_crp_1, products_lib_1, productsSelects, productsShow;
                                var _this = this;
                                return tslib_1.__generator(this, function (_a) {
                                    console.log('PEP ------->>>>> ClientProduct: ', res);
                                    if (res.body.data.length > 0) {
                                        productType = this.abreCuentasService.getproductSelected().product_type;
                                        if (this.channelId === CHANNEL.PORTALO.CODE && productType === BUSINESS_CONST.PRODUCT_TYPE_LIVING && !this.has_second_headline) {
                                            this.abreCuentasService.setPostlogin(true);
                                        }
                                        if (this.abreCuentasService.getproductSelected().product_type !==
                                            BUSINESS_CONST.MULTI) {
                                            res.body.data.forEach(function (record) {
                                                if (record.product_type != null &&
                                                    record.product_number != null &&
                                                    record.product_sub_type != null) {
                                                    // if (
                                                    //   this.abreCuentasService.getproductSelected().product_type !==
                                                    //   BUSINESS_CONST.PRODUCT_TYPE_TC &&
                                                    //   this.abreCuentasService.getproductSelected().product_type !==
                                                    //   BUSINESS_CONST.PRODUCT_TYPE_FREE &&
                                                    //   this.validatorHelperService.validationOfProductDuplicity(
                                                    //     this.cipherService.decrypt(record.product_sub_type),
                                                    //   )
                                                    // ) {
                                                    //   this.navigationService.navigateToGeneralInformation('514');
                                                    //   window.stop();
                                                    //   this.loaderService.forceHide();
                                                    //   return;
                                                    // }
                                                    record.product_type = _this.cipherService.decrypt(record.product_type);
                                                    record.product_number = _this.cipherService.decrypt(record.product_number);
                                                    record.product_sub_type = _this.cipherService.decrypt(record.product_sub_type);
                                                }
                                                return;
                                            });
                                            if (this.abreCuentasService.getproductSelected().product_type ===
                                                BUSINESS_CONST.PRODUCT_TYPE_FREE) {
                                                products_ord = this.countProductsOrd(res);
                                                if (products_ord.length >= limitMaxProducts.ORD) {
                                                    this.sendToErrorProducts();
                                                    return [2 /*return*/];
                                                }
                                            }
                                        }
                                        if (this.abreCuentasService.viewOptionMultiProduct) {
                                            res.body.data.forEach(function (record) {
                                                if (record.product_type != null &&
                                                    record.product_number != null &&
                                                    record.product_sub_type != null) {
                                                    record.product_type = _this.cipherService.decrypt(record.product_type);
                                                    record.product_number = _this.cipherService.decrypt(record.product_number);
                                                    record.product_sub_type = _this.cipherService.decrypt(record.product_sub_type);
                                                }
                                                return;
                                            });
                                            console.log('productos', res.body.data);
                                        }
                                        if (this.abreCuentasService.getproductSelected().product_type ===
                                            BUSINESS_CONST.PRODUCT_TYPE_TC) {
                                            products_tc = res.body.data.filter(function (products) {
                                                return products.product_type === 'TCR';
                                            });
                                            if (products_tc.length >= limitMaxProducts.TCR) {
                                                this.navigationService.navigateToGeneralInformation('514');
                                                return [2 /*return*/];
                                            }
                                        }
                                        if (this.abreCuentasService.getproductSelected().product_type ===
                                            BUSINESS_CONST.MULTI) {
                                            products_tc_1 = res.body.data.filter(function (products) {
                                                // Tarjeta de credito
                                                return products.product_type === 'TCR';
                                            });
                                            products_ord_1 = res.body.data.filter(function (products) {
                                                // Credito personal
                                                return (products.product_type === 'ORD' &&
                                                    _this.parametersService
                                                        .getSetting(OpEnum.ABRE_CUENTAS_CONFIGS)[0]
                                                        .blockedProductsByProductCode.freeInvestment.filter(function (fil) { return fil === products.product_sub_type; }));
                                            });
                                            products_crp_1 = res.body.data.filter(function (products) {
                                                // Credito rotativo
                                                return (products.product_type === 'CRP' &&
                                                    _this.parametersService
                                                        .getSetting(OpEnum.ABRE_CUENTAS_CONFIGS)[0]
                                                        .blockedProductsByProductCode.revolvingCredit.filter(function (fil) { return fil === products.product_sub_type; }));
                                            });
                                            products_lib_1 = res.body.data.filter(function (products) {
                                                // Credito libranza
                                                return products.product_type === 'LIB';
                                            });
                                            if (products_tc_1.length >= limitMaxProducts.TCR &&
                                                products_ord_1.length >= limitMaxProducts.ORD &&
                                                products_crp_1.length >= limitMaxProducts.CRP &&
                                                products_lib_1.length >= limitMaxProducts.LIB) {
                                                this.navigationService.navigateToGeneralInformation('514');
                                                return [2 /*return*/];
                                            }
                                            else {
                                                productsSelects = this.abreCuentasService.getProductsSelects();
                                                productsSelects.forEach(function (product) {
                                                    if (product.product_code === 'ORD') {
                                                        if (products_ord_1.length >= limitMaxProducts.ORD) {
                                                            _this.temproducts.push(product);
                                                        }
                                                    }
                                                    if (product.product_code === 'TCR') {
                                                        if (products_tc_1.length >= limitMaxProducts.TCR) {
                                                            _this.temproducts.push(product);
                                                        }
                                                    }
                                                    if (product.product_code === 'CRP') {
                                                        if (products_crp_1.length >= limitMaxProducts.CRP) {
                                                            _this.temproducts.push(product);
                                                        }
                                                    }
                                                    if (product.product_code === 'LBR') {
                                                        if (products_lib_1.length >= limitMaxProducts.LIB) {
                                                            _this.temproducts.push(product);
                                                        }
                                                    }
                                                });
                                                // if (this.abreCuentasService.getFlowLoan()) {
                                                //   this.flowLoan(res.body.data);
                                                // }
                                                console.log('this.temproducts.length', this.temproducts.length);
                                                console.log('this.productsSelects.length', productsSelects.length);
                                                if (this.temproducts.length === productsSelects.length) {
                                                    this.navigationService.navigateToGeneralInformation('514');
                                                }
                                                else if (this.temproducts.length > 0) {
                                                    this.abreCuentasService.setProductsMax(this.temproducts);
                                                    this.navigationService.nextStep('302');
                                                }
                                            }
                                        }
                                        res.body.data = res.body.data.filter(function (products) {
                                            return (products.product_type !== 'CRP' &&
                                                products.product_type !== 'ORD' &&
                                                products.product_type !== 'TCR');
                                        });
                                        productsShow = this.filterClassProduc(res.body.data);
                                        if (productsShow.length > 0) {
                                            this.abreCuentasService.setClientProduct(true);
                                            this.abreCuentasService.setListClientProduct(productsShow);
                                        }
                                        else {
                                            this.abreCuentasService.setClientProduct(false);
                                        }
                                    }
                                    return [2 /*return*/];
                                });
                            }); })
                                .catch(function (error) {
                                if (error && error.status === 422) {
                                    var regExpRemoveMSString = /\|\s*MS$/;
                                    var errorResponse = error.error && error.error.message
                                        ? JSON.parse(error.error.message.replace(regExpRemoveMSString, ''))
                                        : undefined;
                                    var errorUserNotInSecutiryDb = _this.parametersService.getSetting(OpEnum.ERROR_USER_NOT_IN_SECURITY_DB);
                                    if (errorResponse && errorResponse.Status.statusDesc === errorUserNotInSecutiryDb) {
                                        _this.isNewClient = true;
                                        return _this.enableNextButton();
                                    }
                                }
                                _this.navigationService.navigateToGeneralInformation('127');
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Filtrar productos no habilitados para transacciones.
     */
    PoliticallyExposedPersonComponent.prototype.filterClassProduc = function (body) {
        var products = body;
        var no_transaction = this.parametersService.getSetting(OpEnum.NO_TRANSACTION_PRODUCTS);
        no_transaction.forEach(function (element) {
            products = products.filter(function (product) { return product.product_sub_type !== element; });
        });
        return products;
    };
    PoliticallyExposedPersonComponent.prototype.flowLoan = function (data) {
        var _this = this;
        console.log('data', data);
        var products_tc = data.filter(function (products) {
            var tcr = _this.cipherService.decrypt(products.product_type);
            return tcr === 'TCR';
        });
        var products_cr = data.filter(function (products) {
            return products.product_type === 'CRP';
        });
        var products_lib = data.filter(function (products) {
            return products.product_type === 'ORD' && products.product_sub_type === '371'
                || products.product_sub_type === '382' || products.product_sub_type === '439';
        });
        console.log('prueba lib', products_lib);
        console.log('prueba cr', products_cr);
        console.log('prueba tc', products_tc);
        // if (this.abreCuentasService.getFlowLoan() &&
        // this.abreCuentasService.getAgreementDetailSelected().agreement_operation_flag === BUSINESS_CONST.AGREEMENT_OPERATION_FLAG_SI) {
        //   this.navigationService.navigateToGeneralInformation('134');
        // } else if (this.abreCuentasService.getAgreementDetailSelected().agreement_operation_flag === BUSINESS_CONST.AGREEMENT_OPERATION_FLAG_NO) {
        //   this.navigationService.navigateToGeneralInformation('514');
        // }
    };
    // TCR
    /**
     * Carga datos predefinidos para la variable IsPEP
     *
     * *Charges predefined data by attribute IsPEP
     */
    PoliticallyExposedPersonComponent.prototype.getData = function () {
        var additional_information = this.abreCuentasService.getCustomerData().basic.additional_information[0];
        var information = additional_information.key === 'Es Usted PEP?';
        var pep = information === true ? 'si' : 'no';
        this.FiProperty();
    };
    PoliticallyExposedPersonComponent.prototype.FiProperty = function () {
        this.IsPEP = {
            elementId: 2,
            value: 'No',
            checked: true,
        };
        if (this.has_second_headline) {
            this.abreCuentasService.setFiPropertySecondHeadline('IsPEP', this.IsPEP);
            this.IsPEP = this.abreCuentasService.getFiPropertySecondHeadline('IsPEP');
            return;
        }
        this.abreCuentasService.setFiProperty('IsPEP', this.IsPEP);
        this.IsPEP = this.abreCuentasService.getFiProperty('IsPEP');
    };
    /**
     * Valida si el botón del componente esta habilitado o no
     *
     * *Validates is the button component is enabled or not*
     */
    PoliticallyExposedPersonComponent.prototype.enableNextButton = function () {
        this.isBtnDisabled = false;
    };
    /**
     * Se ejecuta cuando se selecciona una opción de la lista
     *
     * *Executes when an option list is selected*
     * @param event
     */
    PoliticallyExposedPersonComponent.prototype.selectPEP = function (event) {
        this.IsPEP = {
            elementId: event.value === this.copyService.copies.identification_pep_yes ? 1 : 2,
            value: event.value,
            checked: true,
        };
        this.has_second_headline
            ? this.abreCuentasService.setFiPropertySecondHeadline('IsPEP', this.IsPEP)
            : this.abreCuentasService.setFiProperty('IsPEP', this.IsPEP);
    };
    /**
     * Evento para cambiar el estado de checkbox y establece la propiedad
     *
     * *Summary Event to change checkbox and set Prop*
     *
     * @param {any} event
     */
    PoliticallyExposedPersonComponent.prototype.checkboxChange = function (event) {
        if (event.checked) {
            this.isBtnDisabled = false;
        }
        else {
            this.isBtnDisabled = true;
        }
        this.checkboxTerms.checked = event.checked;
        this.has_second_headline
            ? this.abreCuentasService.setFiPropertySecondHeadline('checkboxTerms', this.checkboxTerms)
            : this.abreCuentasService.setFiProperty('checkboxTerms', this.checkboxTerms);
    };
    PoliticallyExposedPersonComponent.prototype.downloadPdf = function () {
        this.channelCommunicatorService
            .getImpl()
            .openPdf(this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].pdfUrl);
    };
    /**
     * Servicio para enviar datos a Google analytics
     *
     * *Send data to Google Analytics*
     */
    PoliticallyExposedPersonComponent.prototype.toggleModal = function (clickEvent) {
        var tagPageName = this.navigationService.getCurrentStep().tag_name;
        try {
            var changes = [
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].value,
                },
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"]
                        .value,
                },
            ];
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.link,
                    position: EVENT.customCategory.position.top,
                },
                action: EVENT.customAction.click,
                label: EVENT[tagPageName + "E1customLabel"],
            };
            this.taggingServices.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log("Error en. " + error);
        }
        switch (clickEvent.type) {
            case 'primary':
                this.downloadPdf();
                break;
            case 'click':
                this.showModal = true;
                this.navigationService.pageLoadTag(false, ['pv5', 'pv109', 'pv69', '']);
                break;
            case 'close':
                this.showModal = false;
                break;
            default:
                break;
        }
    };
    /**
     * Se ejecuta cuando se da clic en el botón continuar el componente
     *
     * *It executes when the burron continue in the component is clicked*
     */
    PoliticallyExposedPersonComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bitacoraEvent, bitacoraEventTerms;
            return tslib_1.__generator(this, function (_a) {
                this.sendTagging('next', 'bottom', '2');
                if (this.taggingServices.isFirmlyAprovedMono()) {
                    this.sendContinueButtonEvent();
                }
                // await this.productChannel();
                this.abreCuentasService.setListIsPEP(this.IsPEP.value);
                bitacoraEvent = "is_pep_" + this.IsPEP.value;
                this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                bitacoraEventTerms = 'term_condition_accept';
                this.bitacoraService.saveDataInBitacora(bitacoraEventTerms);
                console.log('PEP >>> next');
                if (this.abreCuentasService.getUserJemelii() && this.abreCuentasService.getproductSelected().product_type !==
                    BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
                    this.navigationService.nextStep('201');
                }
                else {
                    this.navigationService.nextStep('200');
                }
                return [2 /*return*/];
            });
        });
    };
    PoliticallyExposedPersonComponent.prototype.callClientExistInformationService = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var documentInfo, parms;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        documentInfo = this.abreCuentasService.getDocumentInfo();
                        parms = {
                            data: {
                                document: {
                                    number: documentInfo.document_number,
                                    type: documentInfo.document_type,
                                },
                            },
                        };
                        return [4 /*yield*/, this.identificationService
                                .getClientInformation(parms)
                                .then(function (resp) {
                                if (resp) {
                                    if (resp.status === 200) {
                                        if ((_this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                                            _this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) &&
                                            !_this.ageValidation(resp.body.data.basic.birthdate)) {
                                            _this.navigationService.navigateToGeneralInformation('106');
                                            return;
                                        }
                                        _this.abreCuentasService.setProspectResponse({ client: true });
                                        var data = resp.body.data.basic;
                                        _this.abreCuentasService.setCustomerData(resp.body.data);
                                        _this.validatorHelperService.setCustomerDataClient();
                                        _this.getData();
                                        var item = data.additional_information.find(function (x) { return x.key === 'Fecha Expedición Documento Identidad'; });
                                        _this.infoDocument.date_of_issue = item.name;
                                        _this.infoDocument.sex = data.gender;
                                        _this.infoDocument.firstname = data.given_names[0];
                                        _this.infoDocument.middlename = data.given_names[1];
                                        _this.infoDocument.primary_lastname = data.family_names[0];
                                        _this.infoDocument.second_lastname = data.family_names[1];
                                        _this.infoDocument.birthdate = data.birthdate;
                                        _this.abreCuentasService.setDocumentInfo(_this.infoDocument);
                                        var segmentId = resp.body.data.basic.sub_segment_id;
                                        var products = _this.abreCuentasService.getProductsSelects();
                                        var validProduct = products.filter(function (fil) { return fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE; });
                                        if (_this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE
                                            || validProduct.length > 0) {
                                            _this.validateSegment(segmentId);
                                        }
                                        else if (_this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) {
                                            _this.bitacoraService.saveDataInBitacora(segmentId + "_" + _this.helpersService.getProductCodeBySegmentId(segmentId));
                                        }
                                        if (_this.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
                                            _this.callProspect();
                                        }
                                    }
                                    else {
                                        _this.abreCuentasService.caseInfoError('512');
                                        _this.navigationService.nextStep('103');
                                    }
                                }
                                return;
                            })
                                .catch(function (error) {
                                if (error && error.status === 422) { // Cuando no encuentre usuario
                                    _this.isNewClient = true;
                                    return _this.enableNextButton();
                                }
                                _this.navigationService.navigateToGeneralInformation('512');
                                _this.navigationService.pageLoadTag('ErrorQueremosConocerte', ['pv440', '', 'pv576', '']);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PoliticallyExposedPersonComponent.prototype.ageValidation = function (birthDateString) {
        if (!birthDateString) {
            return false;
        }
        var actualDate = new Date();
        var birthDate = new Date(birthDateString);
        var age = actualDate.getFullYear() - birthDate.getFullYear();
        var month = actualDate.getMonth() - birthDate.getMonth();
        if (month < 0 ||
            (month === 0 && actualDate.getDate() < birthDate.getDate())) {
            age--;
        }
        var maxAgeLimit = this.parametersService.getBusinessRule('max_age_limit');
        return age < maxAgeLimit;
    };
    PoliticallyExposedPersonComponent.prototype.validateSegment = function (segment) {
        var availableSegments = this.abreCuentasService.getAbreCuentasConfigs().available_segments;
        var avaliableSegment = availableSegments.find(function (e) { return e.code === segment; });
        if (avaliableSegment && avaliableSegment.valid) {
            return;
        }
        this.navigationService.navigateToGeneralInformation('126');
    };
    PoliticallyExposedPersonComponent.prototype.callProspect = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var document_type, info;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                document_type = '';
                switch (this.infoDocument.document_type) {
                    case '02':
                    case '03':
                        document_type = 'CC';
                        break;
                    case 'I3':
                        document_type = 'TI';
                        break;
                    default:
                        document_type = 'CC';
                        break;
                }
                info = new DocumentModel();
                info.birthdate = this.infoDocument.birthdate.split('-').join('/');
                info.document_number = this.infoDocument.document_number;
                info.document_type = document_type;
                info.firstname = this.infoDocument.firstname;
                info.middlename = this.infoDocument.middlename;
                info.primary_lastname = this.infoDocument.primary_lastname;
                info.second_lastname = this.infoDocument.second_lastname;
                info.sex = this.infoDocument.sex;
                this.identificationService.sendBackDocumentInfo(info);
                this.statusSendBackDocument$ = this.identificationService.statusSendBackDocument$.subscribe(function (status) {
                    if (status.error) {
                        _this.navigationService.navigateToGeneralInformation(status.code);
                    }
                    else {
                        _this.navigationService.nextStep(status.code);
                    }
                    _this.statusSendBackDocument$.unsubscribe();
                });
                return [2 /*return*/];
            });
        });
    };
    PoliticallyExposedPersonComponent.prototype.validateRequestsGZAF = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var documentId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        documentId = this.abreCuentasService.getDocumentInfo().document_number + "_" + this.abreCuentasService
                            .getDocumentInfo().document_type.replace('0', '');
                        return [4 /*yield*/, this.firmlyApprovedService.validateRequestsGZ(documentId).then(function (result) {
                                if (result.code !== '200') {
                                    var bitacoraEvent = "afmulti_pending_process";
                                    _this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                                    _this.navigationService.navigateToGeneralInformation(result.code);
                                    return;
                                }
                                // tslint:disable-next-line:early-exit
                                if (result.code === '200' && result.data.length > 0) {
                                    switch (_this.abreCuentasService.getproductSelected().product_type) {
                                        // TODO: Implementar en esta parte el llamado al servicio para apagar la vitrina.
                                        case 'freeInvestment':
                                            var bitacoraEventFree = 'afcp_pending_process';
                                            _this.bitacoraService.saveDataInBitacora(bitacoraEventFree);
                                            break;
                                        case 'creditCard':
                                            var bitacoraEventTC = 'aftc_pending_process';
                                            _this.bitacoraService.saveDataInBitacora(bitacoraEventTC);
                                            break;
                                        case 'revolvingCredit':
                                            var bitacoraEventRv = 'afcr_pending_process';
                                            _this.bitacoraService.saveDataInBitacora(bitacoraEventRv);
                                            break;
                                        default:
                                            break;
                                    }
                                    _this.navigationService.navigateToGeneralInformation('129');
                                    return;
                                }
                            }).catch(function () {
                                var bitacoraEvent = "afmulti_pending_process";
                                _this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                                _this.navigationService.navigateToGeneralInformation('107');
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PoliticallyExposedPersonComponent.prototype.countProductsOrd = function (response) {
        var _this = this;
        return response.body.data.filter(function (products_free) {
            // Credito personal
            return (products_free.product_type === BUSINESS_CONST.PRODUCT_CODE_ORD &&
                _this.parametersService
                    .getSetting(OpEnum.ABRE_CUENTAS_CONFIGS)[0]
                    .blockedProductsByProductCode.freeInvestment.filter(function (filter) { return filter === products_free.product_sub_type; }));
        });
    };
    PoliticallyExposedPersonComponent.prototype.sendToErrorProducts = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.navigationService.navigateToGeneralInformation('514');
                window.stop();
                this.loaderService.forceHide();
                return [2 /*return*/];
            });
        });
    };
    /* ------------- Taggeo ------------- */
    /* ------------ Taggeo - PageLoad ------------ */
    PoliticallyExposedPersonComponent.prototype.sendPEPPageLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var productsType = {
            ORD: 'LD',
            TCR: 'TC',
        };
        var changes = [
            {
                path: PAGEVIEW_FA.pv1pageName.path,
                value: (isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking) + ":" + COUNTRY_FA.co + ":" + BUSINNESS_FA.pf + ":" + ENVIRONMENT_FA.loggeado + ":" + FAMILY_FA.services + ":" + SUBFAMILY_FA.request + ":" + PRODUCT_FA.request + ":" + PAGEVIEW_FA.pv1pageName.value,
            },
            {
                path: PAGEVIEW_FA.pv1pageFamily.path,
                value: PAGEVIEW_FA.pv1pageFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv1subFamily.path,
                value: PAGEVIEW_FA.pv1subFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv1pageAction.path,
                value: PAGEVIEW_FA.pv1pageAction.value,
            },
            {
                path: PAGEVIEW_FA.pv1pageid.path,
                value: PoliticallyExposedPersonComponent.name,
            },
            {
                path: PAGEVIEW_FA.pv1transactionName.path,
                value: "" + PAGEVIEW_FA.pv1transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
            {
                path: PAGEVIEW_FA.pv1transactionTransactionStep.path,
                value: PAGEVIEW_FA.pv1transactionTransactionStep.value,
            },
        ];
        this.taggingServices.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    /* ------------ Taggeo - Events ------------ */
    PoliticallyExposedPersonComponent.prototype.sendBackButtonEvent = function () {
        this.sendTagging('prev', 'bottom', '1');
        if (!this.taggingServices.isFirmlyAprovedMono()) {
            return;
        }
        var data = [
            {
                path: EVENT_FA_LD.pv1E2setData.pv1E2transactionTransactionStep.path,
                value: EVENT_FA_LD.pv1E2setData.pv1E2transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv1E2setData.pv1E2transactionName.path,
                value: "" + EVENT_FA_LD.pv1E2setData.pv1E2transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.bottom,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv1E2customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    PoliticallyExposedPersonComponent.prototype.sendContinueButtonEvent = function () {
        var data = [
            {
                path: EVENT_FA_LD.pv1E3setData.pv1E3transactionTransactionStep.path,
                value: EVENT_FA_LD.pv1E3setData.pv1E3transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv1E3setData.pv1E3clientElegibility.path,
                value: this.IsPEP.value === 'Sí' ? 'EsPEP' : 'NoEsPEP',
            },
            {
                path: EVENT_FA_LD.pv1E3setData.pv1E3transactionName.path,
                value: "" + EVENT_FA_LD.pv1E3setData.pv1E3transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.bottom,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv1E3customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    PoliticallyExposedPersonComponent.prototype.sendTagging = function (value, position, event) {
        var page = '2';
        var extras = {
            object: 'clientElegibility',
            value: this.IsPEP.value == 'No' ? 'NoEresPEP ' : 'EresPEP',
            pageValue: 'PoliticallyExposedPerson',
        };
        this.taggingService.sendTaggValues(value, page, position, event, extras);
    };
    return PoliticallyExposedPersonComponent;
}());
export { PoliticallyExposedPersonComponent };
